module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/shift-tasks/mobile-task-ddd389.svg";